module.exports = __webpack_public_path__ + "static/media/repair-se.de248d41.svg";